export const VISUAL_CONFIG = {
  GROUP_PADDING: 1,
  MIN_LINE_LENGTH_FOR_LABEL: 40,
  LABEL_OFFSET_ABOVE: 2,
  LABEL_OFFSET_BELOW: -18,
  LABEL_OFFSET_RIGHT: 8,
  LABEL_OFFSET_LEFT: -120,
  Y_LABEL_MIN_WIDTH: 110,
  LINE_STROKE_WIDTH: 1.5,
  LINE_DASH_PATTERN: "4,4",
  COMPONENT_MARKER_RADIUS: 3,
  LABEL_FONT_SIZE: 11,
  ANCHOR_MARKER_SIZE: 6,
  ANCHOR_MARKER_STROKE_WIDTH: 1.5,
} as const

export const COLORS = {
  OFFSET_LINE: "white",
  COMPONENT_MARKER_FILL: "#66ccff",
  COMPONENT_MARKER_STROKE: "white",
  LABEL_TEXT: "white",
} as const
